export default "__VITE_ASSET__F_rK65RS__"